export const isAuth = () => {
    return JSON.parse(localStorage.getItem('REACT_TOKEN_AUTH')) && JSON.parse(localStorage.getItem('REACT_TOKEN_AUTH')).token ? JSON.parse(localStorage.getItem('REACT_TOKEN_AUTH')) : false
}

export const isLoginAsUser = () => {
    return JSON.parse(localStorage.getItem('REACT_TOKEN_AUTH_ORIGIN')) && JSON.parse(localStorage.getItem('REACT_TOKEN_AUTH_ORIGIN')).token ? JSON.parse(localStorage.getItem('REACT_TOKEN_AUTH_ORIGIN')) : false
}